import FishSearch from './fish-search';
import HeroHeader from './hero-header';
import StartSale from './start-sale';
import Tariffs from './tariffs';
import WarehouseSearch from './warehouse-search';
import WarehousesStatistic from './warehouses-statistic';

export { HeroHeader, WarehouseSearch, FishSearch, WarehousesStatistic, StartSale, Tariffs };
